//© all rights reserved to 6over6 Ltd. 2022. This software (the "Software") is the property of 6over6 Ltd. and its licensors. Any use of the Software is strictly prohibited unless an explicit license or permission is granted by 6over6 Ltd.
import axios from "axios";

class CoralogixLogger {
  constructor(store) {
    this.store = store;
    this.coralogix_config = null;
  }

  async init(coralogix_config) {
    this.coralogix_config = coralogix_config;
  }

  log(msg, product_tag, url) {
    const log_data = {
      message: msg,
      product_tag: product_tag,
      webviewUrl: window.location.href,
      url: url,
      channel: "web",
      ...this.store.state.Session,
    };

    if (this.coralogix_config && this.coralogix_config.active) {
      let body = {
        privateKey: this.coralogix_config.secret_key,
        applicationName: this.coralogix_config.app_name,
        subsystemName: "web companion",
        logEntries: [
          {
            timestamp: Date.now(),
            severity: this.coralogix_config.log_level_num
              ? this.coralogix_config.log_level_num
              : 5,
            text: JSON.stringify(log_data),
          },
        ],
      };

      axios.post(this.coralogix_config.url, body).then(
        () => {},
        (error) => {
          console.log(error);
        }
      );
    }
  }
}

export default CoralogixLogger;
